// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"159":"cc6bab42","629":"cc6bab42"}[chunkId] + ".chunk.css";
};